import { Skin } from '@wix/add-panel-common';
import React, { FC } from 'react';
import { SkinContext } from './SkinContext';
import type { SkinProviderProps } from './SkinProvider.types';

export const SkinProvider: FC<SkinProviderProps> = ({ skin, children }) => (
  <SkinContext.Provider value={{ skin, isClassicFacelift: skin === Skin.ClassicFacelift }}>
    {children}
  </SkinContext.Provider>
);
